import React from "react";
import { makeStyles } from "@mui/styles";
import { TextField } from "@mui/material";
import Autocomplete from '@mui/material/Autocomplete';

const useStyles = makeStyles((theme) => ({
  formLine: {
    color: theme.palette.primary.main,
  },
  formLineError: {
    color: theme.palette.error.main,
  },
}));

export default function DropdownSearch({
  currValue,
  items,
  handleChange,
  property,
  title,
  error,
}) {
  const classes = useStyles();

  const changeValue = (event, newVal) => {
    handleChange(newVal);
  };

  return (
    <Autocomplete
      value={currValue}
      className={classes.root}
      options={items}
      getOptionLabel={(option) =>
        property !== undefined ? option[property] || "" : option || ""
      }
      onChange={changeValue}
      renderInput={(params) => (
        <TextField
          variant="standard"
          {...params}
          label={title}
          InputLabelProps={{
            className: error ? classes.formLineError : classes.formLine,
          }} />
      )}
    />
  );
}
